import { inject } from '@angular/core';

import { signalStoreFeature, withMethods } from '@ngrx/signals';

import { GlobalToastService } from '@pp/core/services';

export function withRequestHandler() {
  return signalStoreFeature(
    withMethods(() => {
      const toast = inject(GlobalToastService);

      return {
        showSuccessToast: (messageKey: string, titleKey?: string) => {
          toast.showSuccessWithTitle(messageKey, titleKey);
        },
      };
    }),
  );
}
